<template>
	<div class="vx-row" v-if="isForm">
		<div :class="cssClazz">
			<vs-input
				:disabled="disabled"
				@keypress="num($event)"
				class="w-full"
				v-model="value"
				:danger="danger"
				:danger-text="dangerText"
			/>
		</div>
	</div>
	<vs-col vs-justify="center" vs-align="center" vs-w="colw" v-else>
		<div class="vx-row md:mt-2 lg:mt-2">
			<vs-col class="sm:w-full md:w-11/12 lg:w-11/12">
				<vs-input
					:disabled="disabled"
					@keypress="num($event)"
					class="w-full"
					v-model="value"
					:danger="danger"
					:danger-text="dangerText"
				/>
			</vs-col>
		</div>
	</vs-col>
</template>

<script>
import VueFormGenerator from "vue-form-generator";

export default {
	data() {
		return {
			danger: false,
			dangerText: "",
			cssClazz:
				"vx-col w-full sm:w-full md:w-full mt-2 mb-2 lg:w-1/2 mt-2 mb-2",			
			isForm: true,
			colw: 6
		};
	},
	methods: {
		num: function(event) {
			const allowed = [
				"0",
				"1",
				"2",
				"3",
				"4",
				"5",
				"6",
				"7",
				"8",
				"9",
				"-",
				".",
				","
			];
			const keyPressed = event.key;
			if (allowed.includes(keyPressed) == false) {
				event.preventDefault();
			}
		}
	},
	mounted() {
		if (
			typeof this.schema.cols !== undefined &&
			this.schema.cols == true
		) {
			this.isForm = false;
		}
	},
	mixins: [VueFormGenerator.abstractField]
};
</script>
